<div class="devo-pipeline-opportunities-view-part">
	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="opportunities()"></grid-content>
</div>